// #ifdef H5
import service from './officialAccount';
// #endif

import h5Service from './officialAccount'

// #ifdef MP-WEIXIN
import service from './miniProgram';
// #endif

// #ifdef APP-PLUS
import service from './openPlatform';
// #endif

const wechat = h5Service;

export default wechat;
